import styled from '@emotion/styled';
import { lpPageColors, mainColors } from 'src/assets/colors';

export const Title = styled('h3', { label: 'Title' })`
    margin: 7px 0;
    font-size: 14px;
`;

export const HeaderWrapper = styled('div', { label: 'HeaderWrapper' })`
    display: flex;
    justify-content: space-between;
    background-color: ${lpPageColors.paleGrey};
    padding: 5px 6px;
`;

export const HeaderItem = styled('div', { label: 'HeaderItem' })`
    width: 33%;
`;

export const HeaderTitle = styled('h4', { label: 'HeaderTitle' })`
    font-size: 12px;
    color: ${mainColors.main.primary};
    margin: 0;
    line-height: 1.3;
`;

export const HeaderText = styled('p', { label: 'HeaderText' })`
    font-size: 12px;
    color: ${mainColors.main.primary};
    margin: 0;
    line-height: 1.3;
`;

